import { get } from 'lodash';
import i18next from 'i18next';

import getStatsFromData from '../../../utils/getStatsFromData';

const DEFAULT_CATEGORY = 'none value';
const PRODUCT_TYPE = 'product';
const MODIFIER_TYPE = 'modifier';
const CATEGORY_TYPE = 'category';

// Transform API response nested JSON
// to flat array of rows with a path property
// to be used by the DataGridPro component
export const transformDataToTreeRows = (apiData) => {
  const rows = [];
  const productsByCategory = get(apiData, 'productsByCategory', {});

  Object.keys(productsByCategory).forEach((categoryKey) => {
    const categoryName =
      categoryKey === DEFAULT_CATEGORY ? i18next.t('GENERAL.NONE_VALUE') : categoryKey;
    const categoryData = productsByCategory[categoryKey];
    const categoryStats = getStatsFromData(categoryData);

    // Category row
    const categoryRowId = `category-${categoryKey}`;
    rows.push({
      id: categoryRowId,
      path: [categoryRowId],
      name: categoryName,
      type: CATEGORY_TYPE,
      hasChildren: !!categoryData?.nestedData?.length,
      ...categoryStats,
    });

    // Product rows
    if (!!categoryData?.nestedData?.length) {
      categoryData.nestedData.forEach((product) => {
        const productStats = getStatsFromData(product);
        // Include category in product ID to ensure uniqueness across categories
        const productRowId = `${categoryRowId}-product-${product.id}`;
        rows.push({
          id: productRowId,
          path: [categoryRowId, productRowId],
          name: product.name,
          type: PRODUCT_TYPE,
          productId: product.id,
          hasChildren: !!product?.nestedData?.length,
          ...productStats,
        });

        // Modifier rows (nestedData within product)
        if (!!product?.nestedData?.length) {
          product.nestedData.forEach((modifier) => {
            const modifierStats = getStatsFromData(modifier);
            // Include product in modifier ID to ensure uniqueness across products
            const modifierRowId = `${productRowId}-modifier-${modifier.id}`;
            rows.push({
              id: modifierRowId,
              path: [categoryRowId, productRowId, modifierRowId],
              name: modifier.name,
              type: MODIFIER_TYPE,
              productId: modifier.id,
              hasChildren: false,
              ...modifierStats,
            });
          });
        }
      });
    }
  });

  return rows;
};

export const formatDataForExport = (apiData) => {
  const productsByCategory = get(apiData, 'productsByCategory', {});
  const formattedData = [];

  Object.keys(productsByCategory).forEach((categoryKey) => {
    const categoryName =
      categoryKey === DEFAULT_CATEGORY ? i18next.t('GENERAL.NONE_VALUE') : categoryKey;
    const categoryData = productsByCategory[categoryKey];
    const categoryStats = getStatsFromData(categoryData);

    const nestedData = (categoryData.nestedData || []).map((product) => ({
      ...product,
      ...getStatsFromData(product),
      nestedData: (product.nestedData || []).map((modifier) => ({
        ...modifier,
        ...getStatsFromData(modifier),
      })),
    }));

    formattedData.push({
      name: categoryName,
      nestedData,
      ...categoryStats,
    });
  });

  return formattedData;
};
